import {jwtDecode} from "jwt-decode";

export const isTokenExpired = (token) => {
  try {
    if (!token) {
      console.error("Token is null or undefined");
      return true;
    }

    const decoded = jwtDecode(token);
    
    // If no "exp" field is present in the token, treat it as expired
    if (!decoded.exp) {
      console.error("Token does not have an expiration field (exp)");
      return true;
    }
    
    console.log("Decoded token:", decoded);

    const currentTime = Date.now() / 1000; // Convert current time to seconds
    return decoded.exp < currentTime;
  } catch (error) {
    console.error("Invalid token:", error);
    return true; // Return true if token is invalid
  }
};
